import { createUseStyles } from 'react-jss'
import { black, darkGrey, mediumGrey, trafficGreenDark, trafficRedDark } from '../../../styles/const/colors'
import { scrollableList } from '../../../styles/common'

// these styles are reused in multiple components
const useStyles = createUseStyles({
  showAllRightsCheckbox: {
    display: 'inline-block'
  },
  categoryHeadline: {
    marginTop: '32px'
  },
  rightsList: {
    padding: 0,
    extend: scrollableList
  },
  rightLink: {
    color: black,
    textDecoration: 'none',
    '&:hover': {
      color: darkGrey
    }
  },
  subText: {
    color: mediumGrey,
    marginTop: 2,
    fontSize: 12
  },
  deliveredPercentage: {
    color: trafficGreenDark
  },
  actions: {
    color: trafficRedDark,
    display: 'flex',
    alignItems: 'center'
  },
  fileCol: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    columnGap: 6,
    paddingRight: '0 !important'
  },
  fileIcon: {
    fontSize: '20px',
    maxWidth: '36px'
  },
  dropdownCol: {
    padding: 0,
    display: 'flex',
    justifyContent: 'center'
  }
})

export default useStyles
